import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Vision from './components/Vision';
import Strength from './components/Strength';
import Services from './components/Services';
import Experience from './components/Experience';
import Team from './components/Team';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Enhanced loading with attractive animation
    setTimeout(() => setIsLoading(false), 2500);

    // Intersection Observer for enhanced animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
        }
      });
    }, observerOptions);

    // Observe all elements with animate-on-scroll class
    setTimeout(() => {
      const animateElements = document.querySelectorAll('.animate-on-scroll');
      animateElements.forEach(el => observer.observe(el));
    }, 3000);

    return () => observer.disconnect();
  }, []);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 flex items-center justify-center z-50">
        <div className="text-center">
          <div className="relative mb-8">
            <div className="w-32 h-32 border-4 border-white/20 border-t-cyan-400 rounded-full animate-spin mx-auto"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div className="w-20 h-20 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-2xl animate-pulse">
                <i className="fas fa-shield-alt text-white text-3xl"></i>
              </div>
            </div>
          </div>
          <div className="text-white">
            <div className="text-4xl font-black mb-3 bg-gradient-to-r from-cyan-400 to-blue-400 text-transparent bg-clip-text">RLDS Pvt Ltd</div>
            <div className="text-sm opacity-80 mb-6 text-blue-200">Verification & Due Diligence Services</div>
            <div className="text-lg font-semibold mt-6 animate-pulse">Loading Professional Excellence...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Vision />
      <Strength />
      <Services />
      <Experience />
      <Team />
      <WhyChooseUs />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;